import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PaymentStore } from '../service/payment.store';
import { Observable } from 'rxjs/Observable';
import { Payment } from '../models/payment';

@Injectable()
export class LatestPrepaymentResolver implements Resolve<any> {

    constructor(
        private translateService: TranslateService,
        private paymentStore: PaymentStore
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Payment> {
        const id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_PREPAYMENT'));
        }

        return this.paymentStore.loadLatestPrepayment(id);
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/prepayment.resolver.ts